import { pick } from "lodash";

import { useSkillsManagementContext } from "../contexts/skills_management_context_provider";

export const useSkillManagementCounters = () => {
  const { skillsData } = useSkillsManagementContext();
  const { data } = skillsData;

  const counters = pick(data?.meta.counters?.state_tally, ["created", "approved", "blocked", "merged"]);
  const total = Object.values(counters).reduce((total, counter) => total + (counter || 0), 0);

  return { ...counters, total };
};
